export interface Vessel {
  id: string;
  mmsi?: string;
  imo?: string;
  name: string;
  call_sign?: string;
  flag_iso2?: string;
  vessel_type?: string;
  gross_tonnage?: number;
  deadweight?: number;
  year_built?: number;
  class_society?: string;
  class_status?: string;
  class_expiry?: string;
  port_of_registry?: string;
  registered_owner?: string;
  ship_manager?: string;
  operator?: string;
  updated_at?: string;
}

export interface WikiEnrichment {
  photo: string | null;
  photo_hq: string | null;
  description: string | null;
  extract: string | null;
  wiki_url: string | null;
}

export interface VesselProfile extends Vessel {
  ownership: OwnershipRecord[];
  sanctions: SanctionRecord[];
  risk?: RiskScore;
  recent_inspections: PSCInspection[];
  recent_port_calls: PortCall[];
  live?: LivePosition;
  wiki?: WikiEnrichment;
}

export interface LivePosition {
  lat: number;
  lng: number;
  speed?: number;
  course?: number;
  heading?: number;
  status?: string;
  destination?: string;
  ts?: string;
}

export interface OwnershipRecord {
  ownership_type: string;
  company_name: string;
  valid_from?: string;
  valid_to?: string;
  source?: string;
}

export interface SanctionRecord {
  list_source: string;
  designation: string;
  designation_date?: string;
  removal_date?: string;
}

export interface PSCInspection {
  id: string;
  mou: string;
  port_name?: string;
  country_iso2?: string;
  inspection_date: string;
  inspection_type?: string;
  result?: string;
  detained: boolean;
  deficiency_count: number;
  deficiencies?: PSCDeficiency[];
}

export interface PSCDeficiency {
  deficiency_code?: string;
  description: string;
  action_code?: string;
  rectified: boolean;
}

export interface PortCall {
  id: string;
  port_name?: string;
  port_locode?: string;
  country_iso2?: string;
  arrived_at?: string;
  departed_at?: string;
  inferred: boolean;
}

export interface RiskScore {
  overall_score: number;
  risk_band: 'low' | 'medium' | 'high' | 'critical';
  identity_score?: number;
  movement_score?: number;
  compliance_score?: number;
  ownership_score?: number;
  condition_score?: number;
  signals: RiskSignal[];
  computed_at?: string;
}

export interface RiskSignal {
  type: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
  description: string;
}

export type RiskBand = 'low' | 'medium' | 'high' | 'critical';

export const RISK_COLORS: Record<RiskBand, string> = {
  low: '#16a34a',
  medium: '#d97706',
  high: '#ea580c',
  critical: '#dc2626',
};

export const RISK_BG: Record<RiskBand, string> = {
  low: 'bg-green-100 text-green-800',
  medium: 'bg-amber-100 text-amber-800',
  high: 'bg-orange-100 text-orange-800',
  critical: 'bg-red-100 text-red-800',
};
